/**
 * ConfigResultCard — update-config skill 结果卡片
 *
 * 展示配置状态：hook 类型、配置名称、文件路径。
 */

import { memo } from 'react'
import { Check, Settings, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import './result-cards.less'

interface ConfigResult {
  success: boolean
  hookType?: string
  description?: string
  filePath?: string
  raw?: string
}

export const ConfigResultCard = memo(function ConfigResultCard({
  result,
}: {
  result: ConfigResult
}) {
  return (
    <div className={cn(
      'result-card',
      result.success ? 'result-card--success' : 'result-card--error',
    )}>
      {/* 状态行 */}
      <div className="flex items-center gap-2">
        <div className={cn(
          'h-5 w-5 rounded-full flex items-center justify-center shrink-0',
          result.success ? 'bg-primary/15' : 'bg-destructive/15',
        )}>
          {result.success
            ? <Check className="h-3 w-3 text-primary" />
            : <X className="h-3 w-3 text-destructive" />}
        </div>
        <span className="text-xs font-medium text-foreground/90">
          {result.success ? '配置成功' : '配置失败'}
        </span>
        {result.hookType && (
          <span className="text-[0.65rem] px-1.5 py-0.5 rounded-full bg-secondary/60 text-muted-foreground/60">
            {result.hookType}
          </span>
        )}
      </div>

      {result.description && (
        <div className="flex items-start gap-2 pl-7">
          <Settings className="h-3 w-3 text-muted-foreground/40 mt-0.5 shrink-0" />
          <span className="text-[0.75rem] text-muted-foreground/70 leading-relaxed">
            {result.description}
          </span>
        </div>
      )}

      {result.filePath && (
        <div className="pl-7">
          <span className="text-[0.65rem] font-mono text-muted-foreground/40">
            {result.filePath}
          </span>
        </div>
      )}
    </div>
  )
})
